/** @jsx jsx */
import { Box, Button, Container, Flex, Text, jsx } from 'theme-ui'
import { useIntl } from 'gatsby-plugin-intl'
import { useEffect, useLayoutEffect } from 'react'
import GoodlesLogo from '../Nav/NavMenu/GoodlesLogo'
import FooterDataConsent from './DataConsent'
import LocaleSwitcher from '~/components/IntlComponents/LocaleSwitcher'
import FooterLegal from '~/components/Footer/Legal'
import FooterLinks from '~/components/Footer/Links'
import FooterSocial from '~/components/Footer/Social'
import useFooterQuery from '~/hooks/graphql/queries/intlQueries/use-footer'
import PauseIcon from '~/assets/images/icons/video-player-pause.svg'
import PlayIcon from '~/assets/images/icons/video-player.svg'

export const Footer = ({
  pauseBuggyAnimation,
  setPauseBuggyAnimation,
  footerColors,
}) => {
  const { locale } = useIntl()

  const { catalog, links, legal, social } = useFooterQuery(locale)

  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script')

      script.src =
        'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=SjPwwD'
      script.async = true

      document.body.appendChild(script)

      return () => {
        document.body.removeChild(script)
      }
    }
  }, [])

  return (
    <Box
      as="footer"
      sx={{
        padding: ['2.5rem 0 4rem 0', null, '4.5rem 0'],
        backgroundColor:
          footerColors?.background || 'override.footerBackground',
        color: footerColors?.color || 'override.footerColor',
      }}
    >
      <Container>
        <Flex
          sx={{
            width: 'fit-content',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <GoodlesLogo
            frontColor={footerColors?.logoFront || 'override.logo.altLogoFront'}
            backColor={footerColors?.logoBack || 'override.logo.altLogoBack'}
          />
          <Button
            alt="Pause animation"
            sx={{
              backgroundColor: 'transparent',
              ':hover': { backgroundColor: 'transparent' },
              width: 'fit-content',
              svg: {
                path: {
                  fill: 'secondary',
                },
                circle: {
                  fill: 'primary',
                },
              },
              px: 0,
            }}
            onClick={() => setPauseBuggyAnimation(p => !p)}
          >
            {pauseBuggyAnimation ? <PlayIcon /> : <PauseIcon />}
          </Button>
        </Flex>
        <Flex
          sx={{
            paddingBottom: [null, null, 200],
            flexDirection: ['column', null, 'row'],
          }}
        >
          <FooterLinks links={links.tabs ?? []} catalog={catalog} />
          <Box
            sx={{
              marginTop: ['2rem', '5.625rem'],
              '.klaviyo-form-Smjjca': {
                mt: '-1rem',
              },
            }}
          >
            <Text
              sx={{
                fontSize: '1.5rem',
                fontWeight: 900,
                fontFamily: 'heading',
              }}
            >
              For A Gooder Inbox
            </Text>
            {/* Klaviyo Sign up form */}
            <div className="klaviyo-form-Smjjca"></div>
          </Box>
        </Flex>
        <Flex
          sx={{
            justifyContent: 'space-between',
            flexDirection: ['column', null, 'row'],
            paddingTop: ['1.5rem', null, '0'],
          }}
        >
          <Flex sx={{ justifyContent: 'space-between' }}>
            <FooterLegal links={legal.tabs ?? []} />
            <Box sx={{ display: ['block', 'none'] }}>
              <LocaleSwitcher topRight />
            </Box>
          </Flex>
          <FooterSocial social={social ?? []} />
        </Flex>
        <FooterDataConsent />
      </Container>
    </Box>
  )
}

export default Footer
